import React from 'react'

// styles
import { ContactUsStylesStylesContainer } from './styles/ContactUsStyles'

// icons
import { FiPhoneCall, FiMail } from 'react-icons/fi'

export default function ContactUs(props) {

    return (
        <ContactUsStylesStylesContainer id="contact-sec">
            <div className="container-fluid px-0">
                <div className="content col-12 col-lg-6 mx-auto">

                    {/* details */}
                    <div className="page-details">
                        <div className="container">
                            <div className="page-details-inner">
                                <p className="head-new st-fw-600 text-center mb-3">Contact us</p>

                                <div className="main-sec">
                                    {/* links */}
                                    <div className="links d-flex align-items-center justify-content-center mb-3 mb-lg-5">
                                        {/* link */}
                                        <a href="callto: 917.775.6712" className="text-decoration-none d-flex align-items-center mx-2 mx-lg-4">
                                            <FiPhoneCall className="text-black-50" />
                                            <span className="ms-2 text-dark">917.775.6712</span>
                                        </a>

                                        {/* email */}
                                        <a href="mailto: info@kraveglassusa.com" className="text-decoration-none d-flex align-items-center mx-2 mx-lg-4">
                                            <FiMail className="text-black-50" />
                                            <span className="ms-2 text-primary">info@kraveglassusa.com</span>
                                        </a>
                                    </div>

                                    <div className="insta text-center">
                                        <p className="st-fs-17">Connect with us</p>

                                        {/* email */}
                                        <a 
                                            href="https://instagram.com/kraveglass" 
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-decoration-none d-inline-flex align-items-center st-fw-600 mx-2 mx-auto">
                                            <img 
                                                src="data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Cdefs%3E%3ClinearGradient x1='7.274%' y1='92.726%' x2='92.086%' y2='7.914%' id='a'%3E%3Cstop stop-color='%23FFD521' offset='0%'/%3E%3Cstop stop-color='%23F52400' offset='49.715%'/%3E%3Cstop stop-color='%23B92BB4' offset='100%'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath d='M592 3920c6.518 0 7.335.028 9.895.144 2.555.117 4.3.523 5.826 1.116 1.58.613 2.918 1.434 4.252 2.768 1.334 1.334 2.155 2.673 2.768 4.25.593 1.528 1 3.272 1.116 5.827.116 2.56.144 3.377.144 9.895s-.028 7.335-.144 9.895c-.117 2.555-.523 4.3-1.116 5.826-.613 1.58-1.434 2.918-2.768 4.252-1.334 1.334-2.673 2.155-4.25 2.768-1.528.593-3.272 1-5.827 1.116-2.56.116-3.377.144-9.895.144s-7.335-.028-9.895-.144c-2.555-.117-4.3-.523-5.826-1.116-1.58-.613-2.918-1.434-4.252-2.768-1.334-1.334-2.155-2.673-2.768-4.25-.593-1.528-1-3.272-1.116-5.827-.116-2.56-.144-3.377-.144-9.895s.028-7.335.144-9.895c.117-2.555.523-4.3 1.116-5.826.613-1.58 1.434-2.918 2.768-4.252 1.334-1.334 2.673-2.155 4.25-2.768 1.528-.593 3.272-1 5.827-1.116 2.56-.116 3.377-.144 9.895-.144zm0 4c-6.514 0-7.285.025-9.858.142-2.378.11-3.67.506-4.53.84-1.14.443-1.95.97-2.805 1.825-.854.854-1.382 1.666-1.825 2.805-.334.86-.73 2.152-.84 4.53-.117 2.573-.142 3.344-.142 9.858 0 6.514.025 7.285.142 9.858.11 2.378.506 3.67.84 4.53.443 1.14.972 1.95 1.825 2.805.854.854 1.666 1.382 2.805 1.825.86.334 2.152.73 4.53.84 2.572.117 3.344.142 9.858.142 6.514 0 7.286-.025 9.858-.142 2.378-.11 3.67-.506 4.53-.84 1.14-.443 1.95-.97 2.805-1.825.854-.854 1.382-1.666 1.825-2.805.334-.86.73-2.152.84-4.53.117-2.573.142-3.344.142-9.858 0-6.514-.025-7.285-.142-9.858-.11-2.378-.506-3.67-.84-4.53-.443-1.14-.97-1.95-1.825-2.805-.854-.854-1.666-1.382-2.805-1.825-.86-.334-2.152-.73-4.53-.84-2.573-.117-3.344-.142-9.858-.142zm0 8c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm0 20c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm16-21c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z' transform='translate(-568 -3920)' fill='url(%23a)' fill-rule='evenodd'/%3E%3C/svg%3E" 
                                                alt="" 
                                                className="img-fluid"
                                                height="24"
                                                width="24"
                                            />
                                            <span className="ms-2 text-primary">@kraveglass</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </ContactUsStylesStylesContainer>
    )
}
